import React from 'react';

import { IonAvatar } from '@ionic/react';

import clsx from 'clsx';

import './index.css';
import { AvatarConfig } from './interfaces';

const Avatar: React.FC<AvatarConfig> = ({
  children,
  className,
  color = 'light',
  type = 'filled',
  ...props
}) => {
  return (
    <IonAvatar
      className={clsx('avatar', `ion-color-status-${color}`, type, className)}
      {...props}
    >
      {children}
    </IonAvatar>
  );
};
export default Avatar;
